module.exports = __webpack_public_path__ + "img/d201301-1.4f056b48.jpg";